export const createScopedResetStyles = (styleScope) => `
${styleScope} {
	font-weight: 400;
	color: var(--cvna-color-blue-6);
	font-size: 16px;
	font-family: var(--cvna-font-family);
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	line-height: 1.5;
}

${styleScope} *,
${styleScope} *::before,
${styleScope} *::after {
	box-sizing: border-box;
}
${styleScope} a {
	text-decoration: none;
}
${styleScope} a:hover {
	text-decoration: none;
}
${styleScope} p {
	margin-top: 0;
	margin-bottom: 16px;
	line-height: 1.5;
}
${styleScope} input {
	font-size: inherit;
}
${styleScope} input,
${styleScope} button,
${styleScope} select,
${styleScope} textarea {
	font-family: inherit;
	line-height: inherit;
}
${styleScope} ul {
	list-style: disc;
	padding-inline-start: 40px;
}
${styleScope} li {
	list-style-type: disc;
}
${styleScope} b,
${styleScope} strong {
	font-weight: bolder;
}
`;
